import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, Container, Row, Col, Alert } from 'react-bootstrap';

import Validator from './configValidators/validator';
import ScenarioGroupValidator from './sgValidators/scenarioGroupValidators';
import PropTypes from "prop-types";


const mongoDB = require('./../../../../images/validation/mongodb.png');
const rabbitMQ = require('./../../../../images/validation/rabbitmq.png');
const ami = require('./../../../../images/validation/amazon-machine-image.png');
const terraform = require('./../../../../images/validation/terraform.png');
const sqs = require('./../../../../images/validation/amazon-sqs.png');
const group = require('./../../../../images/validation/group.png')

function OpenLoopValidation(props) {
    console.log("Main Index", props);
    return (
        <>
            <Container fluid>
                <Breadcrumb>
                    <Breadcrumb.Item href=''>
                        <Link to="/welcome">
                            Home
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href=''>
                        <Link to={`/cm_open_loop_topology?open-loop-type=${props['location']['state']['openLoopType']}`}>
                            CAD Topology
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Validation</Breadcrumb.Item>
                </Breadcrumb>
                { ('location' in props && props['location']['state'] !== undefined && Object.keys(props['location']['state']).length > 0) ? (
                    <>
                        <Row>
                            <Col xs={6} lg={6}>
                                <Validator queryString="config-ami-check" icon={ami} title="Config Dynamic Scheduling"/>
                            </Col>
                            <Col xs={6} lg={6}>
                                <Validator queryString="terraform-check" icon={terraform} title="Terraform"/>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: '3%' }}>
                            <Col xs={3} lg={3}>
                                <Validator queryString="mongo-connection" icon={mongoDB} title="Mongo DB"/>
                            </Col>
                            <Col xs={3} lg={3}>
                                <Validator queryString="rabbitmq-connection" icon={rabbitMQ} title="Rabbit MQ"/>
                            </Col>
                            <Col xs={6} lg={6}>
                                <Validator queryString="sqs-queue-length" icon={sqs} title="SQS Queue"/>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: '3%' }}>
                            <Col xs={6} lg={6}>
                                { Object.keys(props).length ? (
                                    Object.keys(props['location']).length ? (
                                        Object.keys(props['location']['state']).length ? (
                                            <ScenarioGroupValidator
                                                topologyId={props['location']['state']['cadTopologyId']}
                                                icon={group}
                                                title="Scenario Groups"
                                            />
                                        ) : (
                                            <Alert>
                                                Location object doesnt has any attribute named &quot;state&quot;
                                            </Alert>
                                        )
                                    ) : (
                                        <Alert variant="danger">
                                            Props object doesn t has any attribute named &quot;location&quot;
                                        </Alert>
                                    )
                                ) : (
                                    <Alert variant="danger">
                                        The component doesnt contain any inside props
                                    </Alert>
                                ) }
                            </Col>
                        </Row>
                    </>
                ) : (
                    <Alert variant="danger">
                        Error occurred while processing this request!!!
                    </Alert>
                )}
            </Container>
        </>
    )
}

OpenLoopValidation.propTypes = {
    location: PropTypes.array,
};

export default OpenLoopValidation;